// Core imports
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Select } from 'antd';

// Misc imports
import { isDevEnv } from '../../utils/is/isDev';
import { LANGUAGE_OPTIONS } from '../../constants/main';

const DEV_LANGUAGE_KEY = 'dev_language_picker';

const DevLanguagePicker = ({ className }) => {
  const { i18n } = useTranslation();

  // Load saved language on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem(DEV_LANGUAGE_KEY);
    if (savedLanguage && i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  if (!isDevEnv()) {
    return null;
  }

  const availableLanguages = Object.keys(i18n.options.resources);

  const languageOptions = LANGUAGE_OPTIONS.filter(lang =>
    availableLanguages.includes(lang.key)
  ).map(lang => ({
    value: lang.key,
    label: lang.icon
  }));

  const handleLanguageChange = (value) => {
    localStorage.setItem(DEV_LANGUAGE_KEY, value);
    i18n.changeLanguage(value);
  };

  return (
    <Select
      value={i18n.language}
      size="small"
      style={{ width: 60 }}
      onChange={handleLanguageChange}
      options={languageOptions}
      className={className}
    />
  );
};

DevLanguagePicker.propTypes = {
  className: PropTypes.string
};

export default DevLanguagePicker;
